import React from 'react';
import PropTypes from 'prop-types';
import Image from './ui/Image';
import Caption from './Caption';
import Slider from './ui/Slider';
import { Grid, Col } from './ui/Grid';

function getImages(props) {
  let images = props.images;
  const img = images[0];
  if (img.to) {
    const arr = [];
    for (let i = img.from; i <= img.to; i++) {
      const obj = {
        name: i,
        type: img.type,
        folder: img.folder,
        large: img.large
      };
      if (img.large) {
        const size = img.sizes[i - img.from];
        obj.size = {
          width: size[0],
          height: size[1]
        };
      }
      arr.push(obj);
    }
    images = arr;
  }
  return images;
}

function Images(props) {
  const images = getImages(props);
  return (
    <div>
      {props.showLarge && (
        <Slider
          images={images}
          selectedImage={images[0]}
          getImage={props.getImage}
          autostart
          parent={props.parent}
        />
      )}
      {props.showList && (
        <Grid cols="3" gap="3">
          {images.map((image, i) => (
            <Col key={i} className="box-border box-border--small box-margin">
              <div>
                <Image
                  type="img-bg"
                  src={props.getImage(image)}
                  className="box-half img-bg--cover img-hover--2"
                  path={props.getPath(props.parent, image)}
                />
              </div>
              <div>
                <Caption className="text-small" {...image} videos={null} />
              </div>
            </Col>
          ))}
        </Grid>
      )}
    </div>
  );
}

Images.defaultProps = { showTiles: false, showLarge: false, showList: false };
Images.propTypes = {
  images: PropTypes.array,
  selectedImage: PropTypes.shape({}),
  showTiles: PropTypes.bool,
  showLarge: PropTypes.bool,
  showList: PropTypes.bool,
  getImage: PropTypes.func.isRequired,
  getPath: PropTypes.func.isRequired,
  parent: PropTypes.shape({}).isRequired
};

export default Images;



// WEBPACK FOOTER //
// ./src/components/Images.jsx